import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { images } from '../lib/assets';
export const mockupUrl = images.mockup;
export function Hero() {
  return <section className="w-full px-4 pb-6 pt-4 text-navy sm:pb-10 sm:pt-8" style={{
    background: 'radial-gradient(ellipse at 50% 60%, #FFFFFF 0%, #FFFFFF 40%, #FBF8F3 70%, #F3E6E8 100%)'
  }} data-id="element-104" data-mp="9ka52wkpoovv">
      <div className="mx-auto max-w-5xl text-center" data-id="element-105" data-mp="1297cu5rar3ad">
        <motion.span initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45
      }} className="inline-flex rounded-full border border-amber/50 bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-amber" data-id="element-106" data-mp="128z0qg300208">Per gli operatori olistici</motion.span>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.05
      }} className="mx-auto mt-3 max-w-3xl font-serif text-[32px] leading-[1.05] tracking-tight text-navy sm:text-6xl" data-id="element-107" data-mp="nbygexn4z9bs">Le tue sedute di tarocchi, Reiki e chakra, <span className="text-sage" data-id="element-108" data-mp="3j9k9t8cxxbej">finalmente organizzate.</span></motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        delay: 0.14
      }} className="mx-auto mt-2 max-w-md text-sm leading-snug text-slate sm:text-lg" data-id="element-109" data-mp="3o85cdefo0765">6 volumi, 60 schede A4 da stampare e 5 bonus: tutto in un solo posto, pronto all’uso.</motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mx-auto mt-3 max-w-xl" data-id="element-110" data-mp="30hhq1o505f02"><img src={mockupUrl} alt="Sistema Energetico Tarocchi · Reiki · Chakra: il libro e alcune schede da stampare" width={1600} height={1280} fetchPriority="high" decoding="async" className="mx-auto block h-auto w-full object-contain mix-blend-multiply" data-id="element-111" data-mp="35akoa9kq5cml" /></motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.28
      }} className="mt-3" data-id="element-112" data-mp="2hjypl8wm14p9"><CTAButton href="#complete-package" pulse size="large" data-id="element-113" data-mp="s21iabtr0dzz">VOGLIO LA MIA BIBLIOTECA</CTAButton><p className="mx-auto mt-2.5 text-xs text-slate sm:text-sm" data-id="element-114" data-mp="s3usu27hfid9">⚡ Accesso immediato <span className="mx-1" data-id="element-115" data-mp="na09x0zpb7f8">·</span> 🖨️ Schede A4 <span className="mx-1" data-id="element-116" data-mp="iboyiltrcouw">·</span> 🛡️ Protezione 7 giorni</p></motion.div>
      </div>
    </section>;
}